"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayPlan = void 0;
var PayPlan;
(function (PayPlan) {
    PayPlan["AUTOMATIC_PAYMENT"] = "Automatic Payment";
    PayPlan["TWO_PAY"] = "2 Pay";
    PayPlan["THREE_PAY"] = "3 Pay";
    PayPlan["FOUR_PAY"] = "4 Pay";
    PayPlan["FIVE_PAY"] = "5 Pay";
    PayPlan["SIX_PAY"] = "6 Pay";
    PayPlan["FULL_PAY"] = "Full Pay";
    PayPlan["AP_THREE_PAY"] = "Automatic Payment (Bank) - 3 Pay";
    PayPlan["AP_FIVE_PAY"] = "Automatic Payment (Bank) - 5 Pay";
    PayPlan["AP_SIX_PAY"] = "Automatic Payment (Bank) - 6 Pay";
    PayPlan["AP_FULL_PAY"] = "Automatic Payment (Bank) - Full Pay";
})(PayPlan = exports.PayPlan || (exports.PayPlan = {}));
